export default __webpack_public_path__ + "static/media/8a.8f73d2c5.png";